import { useAlert } from "../components/contextProviders/AlertProvider";
import { useBack } from "../http";
import { AdmissionEmployeeDTO } from "../types/AdmissionEmployeeDTO";
import { CreatedEmployeeDTO } from "../types/CreatedEmployeeDTO";
import { EmployeeDTO } from "../types/EmployeeDTO";
import { PositionDTO } from "../types/PositionDTO";
import { SectorDTO } from "../types/SectorDTO";

export class EmployeeService {
	constructor() {}
	axiosInstance = useBack();
	showError = useAlert().showError;

	async getEmployeeBasicData(cpf: string, cnpj: string) {
		try {
			const response = await this.axiosInstance
				.get<EmployeeDTO>(`/employee-basic-data?cpf=${cpf}&cnpj=${cnpj}`);
			return { ...response };
		} catch (error) {
			this.showError();
			console.log(`Não foi possível obter as informações do funcionário com cpf ${cpf}`, error);
			return undefined;
		}
	}

	async getSectorsByCnpj(cnpj: string) {
		try {
			const response = await this.axiosInstance
				.get<SectorDTO[]>(`/sector?cnpj=${cnpj}`);
			return { ...response };
		} catch (error) {
			this.showError();
			console.log(`Não foi possível obter os setores da empresa ${cnpj}`, error);
			return undefined;
		}
	}

	async getPositionsBySector(sectorId: string) {
		try {
			const response = await this.axiosInstance
				.get<PositionDTO[]>(`/position?sector=${sectorId}`);
			return { ...response };
		} catch (error) {
			this.showError();
			console.log(`Não foi possível obter os cargos dosetor ${sectorId}`, error);
			return undefined;
		}
	}

	async createEmployee(newEmp: EmployeeDTO) {
		try {
			const response = await this.axiosInstance
				.post<string>(`/employee`, newEmp);
			return { ...response };
		} catch (error) {
			this.showError();
			console.log(`Não foi possível criar o novo funcionário`, error);
			return undefined;
		}
	}

	async getCreatedEmployees() {
		try {
			const response = await this.axiosInstance.get<CreatedEmployeeDTO[]>(`/employee`);
			return { ...response };
		} catch (error) {
			this.showError('Não foi possível obter os funcionários criados');
			console.log(error);
			return undefined;
		}
	}

	async getAdmissionScheduling(id: string) {
		try {
			const response = await this.axiosInstance.get<AdmissionEmployeeDTO>(`/employee/${id}/scheduling`);
			return { ...response };
		} catch (error) {
			this.showError('Não foi possível obter o agendamento disponível');
			console.log(error);
			return undefined;
		}
	}

	async confirmAdmissionScheduling(id: string, value: AdmissionEmployeeDTO) {
		try {
			const response = await this.axiosInstance.post(`/employee/${id}/scheduling`, value);
			return { ...response };
		} catch (error) {
			this.showError('Não foi possível confirmar o agendamento! Tente novamente mais tarde.');
			console.log(error);
			return undefined;
		}
	}

	async approveEmployee(id: number, data: EmployeeDTO) {
		try {
			const response = await this.axiosInstance.post(`/employee/${id}/approve`, data);
			return { ...response };
		} catch (error) {
			this.showError('Erro. Não foi possível aprovar o cadastro do funcionário');
			console.log(error);
			return undefined;
		}
	}

	async scheduleInternally(id: number) {
		try {
			await this.axiosInstance.post(`/employee/${id}/schedule-internally`);
		} catch (error) {
			this.showError('Erro. Não foi possível agendar internamente o funcionário');
			console.log(error);
			return undefined;
		}
	}
}